import groupBy from 'lodash/groupBy';
import { v4 } from 'uuid';
import sortBy from 'lodash/sortBy';
import mapValues from 'lodash/mapValues';
import { EMPTY_ARRAY } from './immutable';

export function visitConditionPaths({
  conditionPaths = EMPTY_ARRAY,
  visitCondition,
  visitConditionPath,
}) {
  conditionPaths.forEach(conditionPath => {
    visitConditionPath?.(conditionPath);
    const { conditions = [], sets = [] } = conditionPath.config;
    conditions.forEach(condition => visitCondition?.(condition, conditionPath));
    sets.forEach(set =>
      (set.conditions ?? []).forEach(condition =>
        visitCondition?.(condition, conditionPath, set),
      ),
    );
  });
}

export function buildConditionPathsByBlockId(conditionPaths) {
  // add frontend-only identifiers used for validation
  visitConditionPaths({
    conditionPaths,
    visitCondition: condition => {
      // eslint-disable-next-line no-param-reassign
      condition.leftInputId = v4();
      // eslint-disable-next-line no-param-reassign
      condition.rightInputId = v4();
    },
  });

  return mapValues(
    groupBy(conditionPaths, path => path.block.id),
    paths => sortBy(paths, 'orderNum'),
  );
}
